import { axiosInstance } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const saveSolicitud = (data) => {
  return axiosInstance
    .post("saveSolicitud/", data)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return Promise.reject(err);
    });
};

export default { saveSolicitud };
